var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-base"},[_c('screen-topbar',{attrs:{"title":_vm.title,"sub-title":_vm.subTitle}}),_vm._v(" "),_c('div',{staticClass:"screen-content-wrapper",class:{ flex: _vm.flex }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }